/* eslint-disable no-underscore-dangle */
/*
 * @Description:
 * @Author: 鲁大师
 * @Date: 2020-05-18 15:46:30
 * @LastEditors: 鲁大师
 * @LastEditTime: 2020-10-16 10:01:12
 * 注：这个类是直播SDK的入口，是从live-h5-sdk中抽出来的,其中包含平台判断逻辑，这里其实用不到
 */
import { getPlatform } from "@/utils/platform";
import { getBaseurl } from "@/utils/url-parse";
import { API } from "@akc/biz-api";
import Cookie from "js-cookie";
import { liveUserTrusteeship } from "../../api/live";
import { xdUserRoleEnum, xdUserTypeEnum } from "./const";
// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
const FN = () => {};
const baseUrl = getBaseurl();

export default class Live {
  constructor({
    env,
    // nodeEnv,
    onLoginParam,
  }) {
    this.env = env || "production";
    // this.nodeEnv = nodeEnv;
    // 请求的配置
    // localStorage.setItem("live-sdk-config", JSON.stringify(props));
    // 获取登录接口的参数
    this.onLoginParam = onLoginParam;
  }
  // 登录接口参数
  _userInfo = null;
  // 是否登录成功
  _isLogin = false;
  // 登录接口返回结果
  loginAction = null;
  // 用户code
  userCode = null;
  // 用户角色
  userRole = null; // 角色枚举
  // 用户类型
  userType = null; // 1店铺/商家，2游客/C客户
  // 项目运行环境，开发development，测试test，生产production
  env = "production";
  // node环境
  // nodeEnv = "";

  /**
   * 登录并执行回调
   * @param {Function} cb - 登录成功后的回调函数
   */
  ready(cb) {
    // 如果是app和微信小程序（嵌套webview）直接登录
    const { isApp, isMini } = getPlatform();
    if (isApp || isMini) {
      cb();
      return;
    }
    // 否则是H5，已经登录
    if (this._isLogin) {
      cb();
      return;
    }
    // 获取登录接口的参数,并登录
    this._userInfo = this.onLoginParam();
    return this.login(this._userInfo, cb);
  }

  /**
   * 三方用户信息托管到直播
   * @param {Object} params - 登录参数
   * @param {Function} cb - 登录成功后的回调函数
   * @returns {Promise} - 登录结果
   */
  login(params = this.onLoginParam(), cb) {
    this._userInfo = params;
    // 调用login方法，一直进行最新的请求
    if (!cb) {
      this.loginAction = liveUserTrusteeship(params);
    }
    // 没有请求的时候先获取token方法
    if (this.loginAction === null) {
      this.loginAction = liveUserTrusteeship(params);
    }

    return new Promise((resolve, reject) => {
      this.loginAction
        .then(res => {
          // 处理特殊情况{"code":11001022,"message":"连接直播失败,请重试","success":true,"data":{}}，此时res=rsp.data={}
          if (!res?.token) {
            throw new Error("登录失败");
          }
          this.loginAfter(res, cb);
          return resolve(res);
        })
        .catch(err => {
          Cookie.set("x-h5-auth-token-live-sdk", "", "");
          return reject(err);
        });
    });
  }

  // h5登录完成之后
  loginAfter(res = {}, cb) {
    // 设置cookie等消息
    const {
      token,
      tokenExpirationTime,
      userRole = xdUserRoleEnum.XD_USER_ROLE_VISITOR,
      userCode,
    } = res;
    // 直播登录token，直播相关请求会调取
    Cookie.set("x-h5-auth-token-live-sdk", token, tokenExpirationTime);
    this._isLogin = true;
    // useCode，this.$live.userCode
    this.userCode = userCode;
    // userRole ,this.$live.userRole 1饷店C 2饷店店主 3饷店店长 99游客
    this.userRole = userRole;
    if (
      userRole === xdUserRoleEnum.XD_USER_ROLE_MORMAL_BUYER ||
      userRole === xdUserRoleEnum.XD_USER_ROLE_VISITOR
    ) {
      // C角色
      this.userType = xdUserTypeEnum.XD_USER_TYPE_C;
    } else {
      // B，b角色
      this.userType = xdUserTypeEnum.XD_USER_TYPE_BB;
    }
    if (cb) {
      cb();
    }
  }
}
